import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { VendorGame } from '~/features/vendor-game/types/vendor-game.type';

/**
 * 벤더별 게임 목록 조회
 * @description 특정 벤더의 게임 목록을 조회합니다
 * @endpoint GET /admin/vendor-games/vendors/:vendorId
 * @param vendorId - 벤더 ID
 * @returns 벤더 게임 목록
 */
export function getVendorGameListByVendorApi(vendorId: number) {
  return axiosInstance.get<ApiResponse<VendorGame[]>>(`/admin/vendor-games/vendors/${vendorId}`);
}
